/**
 * The member reviews the download page shows, in the order production shows
 * them, less the six whose wording breaks the member-copy rules. Each names its `signup` catalog keys in full, so the catalog's
 * dead-key scan can see them. The text lives in the catalog only; every
 * member sees the same list, and nothing reads or branches on it.
 */
export const DOWNLOAD_REVIEWS = [
  {
    id: 'spending',
    title: 'download.reviews.spending.title',
    body: 'download.reviews.spending.body',
  },
  {
    id: 'didntThink',
    title: 'download.reviews.didntThink.title',
    body: 'download.reviews.didntThink.body',
  },
  {
    id: 'library',
    title: 'download.reviews.library.title',
    body: 'download.reviews.library.body',
  },
  {
    id: 'amazing',
    title: 'download.reviews.amazing.title',
    body: 'download.reviews.amazing.body',
  },
  {
    id: 'effective',
    title: 'download.reviews.effective.title',
    body: 'download.reviews.effective.body',
  },
] as const;

export type DownloadReviewId = (typeof DOWNLOAD_REVIEWS)[number]['id'];
